import type { CSSProperties } from "react";
import { useEffect, useState } from "react";
import { useIsOnScreenKeyboardOpen } from "./useIsOnScreenKeyboardOpen";

export function useKeyboardAwareDrawerStyle(enabled = true): CSSProperties | undefined {
	const isKeyboardOpen = useIsOnScreenKeyboardOpen();
	const [visualViewportHeight, setVisualViewportHeight] = useState<number | null>(null);

	useEffect(() => {
		const viewport = window.visualViewport;
		if (!enabled || !isKeyboardOpen || !viewport) {
			setVisualViewportHeight(null);
			return;
		}

		const update = () => setVisualViewportHeight(viewport.height);
		update();
		viewport.addEventListener("resize", update);
		return () => viewport.removeEventListener("resize", update);
	}, [enabled, isKeyboardOpen]);

	if (!enabled || !isKeyboardOpen || !visualViewportHeight) return undefined;

	return { maxHeight: `${visualViewportHeight}px` };
}
